import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaTimes } from 'react-icons/fa';
import Select from 'react-select';

import Const from '../../util/Constants';
import FieldController from '../../controller/FieldController';

class FilterCountry extends React.Component {

  constructor(props) {
    super(props);
    const filter = props.filter;
    this.conditions = FieldController.getConditions(props.field.field_type);
    let condition = filter ? filter.condition : FieldController.In;
    condition = this.conditions.find(item => condition === item.value);
    
    this.countries = reactLocalStorage.getObject(Const.Countries);
    const countries = this.countries.filter(country => 
      filter && filter.value.includes(`${Const.Opt}${country.value}${Const.Opt}`));
    this.state = { condition: condition, countries };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.field.field_key !== this.props.field.field_key) {
      const filter = props.filter;
      let condition = filter ? filter.condition : FieldController.In;
      condition = this.conditions.find(item => condition === item.value);
      
      const countries = this.countries.filter(country => 
        filter && filter.value.includes(`${Const.Opt}${country.value}${Const.Opt}`));
      this.setState( { ...this.state, condition: condition, countries });
    }
  }

  onConditionChanged = select => {
    this.setState({ ...this.state, condition: select });
    if(select.value === FieldController.Empty || select.value === FieldController.NotEmpty) {
      this.props.onValueChange(this.props.field.fieldKey, select.value, '', this.props.field.model_key);
    } else {
      this.props.deleteFilter(this.props.field.fieldKey, this.props.field.model_key);
    }
  }

  onOptionChange = selected => {
    let tmp  = '';
    for(let i = 0; i < selected.length; i++) { tmp = tmp + selected[i].value + '~'; }
    tmp = tmp !== '' ? '~' + tmp : '';
    if(tmp !== '') {
      this.props.onValueChange(this.props.field.fieldKey, this.state.condition.value, tmp, this.props.field.model_key);
    } else {
      this.props.deleteFilter(this.props.field.fieldKey, this.props.field.model_key);
    }
    this.setState({ ...this.state, countries: selected });
  }

  render() {
    const condition = this.state.condition ? this.state.condition.value : '';
    const isFilter = (this.state.countries && this.state.countries.length > 0)
      || !FieldController.showSelect(Const.MultiSelect, condition);
    return (
      <>
        <div className="row pt-2">
          <div className="col-md-5">
            <p className="headingp">
              {this.props.field.model_key ? <>{this.props.field.model_name}<br/></> : ''}{this.props.field.label_name}
            </p>
          </div>
          <div className={`col-md-${isFilter ? 5: 7}`}>
            <Select value={this.state.condition} onChange={this.onConditionChanged}
              options={this.conditions} isSearchable={true} />
          </div>
          { isFilter ? <div className="col-md-1"><FaTimes 
            onClick={() => this.props.resetFilter(this.props.field.field_key)}/></div> : null }
        </div>

        <div className="row pt-2">
          { FieldController.showSelect(Const.MultiSelect, condition) ?
            <div className="col-md-12">
              <Select value={this.state.countries} options={this.countries} isSearchable={true}
                onChange={selected => this.onOptionChange(selected)}
                isClearable={true} isMulti={true} />
            </div> : null
          }
        </div>
        <hr />
      </>
    );
  }
}


export default FilterCountry;